export default "__VITE_ASSET__CQIH0P8S__"